import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDateReport'
})
export class CustomDateReportPipe implements PipeTransform {

  //constructor(private datePipe: DatePipe) {}

  transform(value: any): string | null {
    if (!value) return null;
    return new DatePipe('en-US').transform(value, 'dd-MMM-yyyy');
  }


}
